import { Controller } from "@hotwired/stimulus"

// Copies the source target's value to the clipboard and flashes short
// feedback on the trigger button (used for the Google Calendar feed URL).
export default class extends Controller {
  static targets = ["source", "button"]

  async copy() {
    const text = this.sourceTarget.value || this.sourceTarget.textContent.trim()
    await navigator.clipboard.writeText(text)
    if (this.hasButtonTarget) {
      const original = this.buttonTarget.textContent
      this.buttonTarget.textContent = "Đã sao chép"
      setTimeout(() => { this.buttonTarget.textContent = original }, 1500)
    }
  }
}
